<template>
  <b-avatar-group size="35px">
    <b-avatar
      v-for="(item, index) in signers"
      :key="index"
      badge badge-left
      variant="primary"
      :badge-variant="item.variant"
      :text="item.userInitials"
      :src="item.avatar"
      v-b-popover.hover.top="item.name"
    >
      <template #badge><b-icon :icon="item.icon"></b-icon></template>
    </b-avatar>
  </b-avatar-group>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      signers: []
    }
  },
  methods: {
    async loadSignersAvatars () {
      for (const [index, item] of this.value.signers.entries()) {
        const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${item.id}`)
        const userInfo = res.data
        const signer = {
          name: `${userInfo.firstname} ${userInfo.lastname}`,
          userInitials: res.data?.userInitials,
          avatar: userInfo?.profilePicture || '',
          variant: index < this.value.signatures ? 'success' : 'danger',
          icon: index < this.value.signatures ? 'check' : 'dash-circle'
        }
        this.signers.push(signer)
      }
    }
  },
  async created () {
    try {
      await this.loadSignersAvatars()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
